<template>
  <div class="page pageAsOverlay thePage">

    <div class="prelative">
      <AppHead style="pointer-events: none"></AppHead>
      <div class="absCatcher" @click="closeDialog"
      ></div>
    </div>

    <div class="spacer-25"></div>

    <v-container grid-list-lg class="text-center">
      <div v-if="!started">
        <h3 v-if="detectedCode">Erkannte Tischnummer</h3>
        <v-text-field
          v-if="detectedCode"
          v-model="detectedCode" class="mt-10"
          label="Tischnummer"
          placeholder=""
          illed
          required
        ></v-text-field>
        <div>
          <!--          <v-btn class="mt-5 btn-df" v-if="detectedCode && detectedCode.length > 0"-->
          <!--                 @click.native.passive="confirm">-->
          <!--            Bestätigen-->
          <!--          </v-btn>-->
        </div>
        <div>
          <v-btn class="btn-df mt-15" @click="startScan">Tisch QR-Code einscannen</v-btn>
        </div>
        <div>
          <v-btn class="mt-10 btn-mini"
                 @click.native.passive="cancle">
            Abbrechen
          </v-btn>
        </div>
      </div>

      <!--      <div v-show="started">-->
      <!--        <div></div>-->
      <!--        &lt;!&ndash;        <v-autocomplete class="roundInput" v-model="selectedCam"&ndash;&gt;-->
      <!--        &lt;!&ndash;                        label="Kamera ändern" v-if="started && vCams.length > 1"&ndash;&gt;-->
      <!--        &lt;!&ndash;                        hide-details&ndash;&gt;-->
      <!--        &lt;!&ndash;                        :items="vCams" outlined return-object full-width>&ndash;&gt;-->
      <!--        &lt;!&ndash;        </v-autocomplete>&ndash;&gt;-->

      <!--        &lt;!&ndash;      <div class="mt-5 mb-5">&ndash;&gt;-->
      <!--        &lt;!&ndash;        <div class="pt-1 pb-1" v-for="cam of cams" @click="setCam(cam.id)">{{ cam.id }} | {{ cam.label }}</div>&ndash;&gt;-->
      <!--        &lt;!&ndash;      </div>&ndash;&gt;-->
      <!--      </div>-->

    </v-container>

    <div class="superCenter">
      <video id="tableQrVideoElem" class="vVideo"></video>
    </div>

    <div class="pt-10 text-center" v-show="started">
      <div class="text-center pt-4 pb-4">
        <div>
          <v-btn class="btn-mini" @click="stopScan">Abbrechen</v-btn>
        </div>

        <!--        <div>DEBUG cams length: {{ cams.length }}</div>-->
        <!--          <h4 class="mt-5" v-if="detectedCode">QR-Code: {{ detectedCode }}</h4>-->
      </div>

      <h3 v-if="showHint" class="mt-6">Bitte überprüfe die Kamera-Berechtigung in deinen Browser-Einstellungen, falls
        die Kamera jetzt nicht
        angezeigt wird.</h3>
    </div>

  </div>
</template>

<script>
import QrScanner from 'qr-scanner';
import {ebus} from "@/vendor/ebus";
import store from "@/store/store";
import * as util from "@/vendor/util";
import AppHead from "@/components/AppHead.vue";
import {parseTableOrNull} from "@/vendor/util"; // if installed via package and bundling with a module bundler like webpack or rollup

export default {
  name: "TableQrCodeScanner",
  components: {AppHead},

  data: () => ({
    started: false,
    showHint: false,
    initCompleted: false,

    selectedCam: null,

    detectedCode: '', // contains data and corner points
    qrScanner: null,
    cams: [], //contains id and label
  }),

  // computed: {
  //   vCams() {
  //     return this.cams.map(c => {
  //       return {text: c.label, value: c.id}
  //     });
  //   },
  // },

  watch: {
    selectedCam: {
      handler: function handler(newVal) {
        if (newVal && newVal.value) {
          this.setCam(newVal.value);
        }
      }
    },
  },

  created() {
    console.log('QrCodeScanner created...');
    ebus.$on('triggerQrCodeScanner', () => {
      this.startScan();
    });
  },

  mounted() {
    // this.initScanner();
  },

  beforeDestroy() {
    try {
      this.qrScanner.stop();
      this.qrScanner.destroy();
      this.qrScanner = null;
    } catch (e) {

    } finally {
      this.started = false;
    }
  },

  methods: {
    confirm() {
      ebus.$emit('userEnteredTable', this.detectedCode);
      store.commit('showDialogContainer', false);
    },
    cancle() {
      this.doCancle(this, store);
    },
    closeDialog() {
      this.stopScan();
      store.commit('showDialogContainer', false);
    },
    doCancle(_this, _store) {
      _this.stopScan();
      _store.commit('showDialogContainer', false);
      setTimeout(() => {
        util.jumpToTop(true);
      }, 50);
    },
    initScanner() {
      let videoElem = window.document.getElementById('tableQrVideoElem');

      let _this = this;
      let _store = store;

      // QrScanner.hasCamera().then()

      //https://github.com/nimiq/qr-scanner
      // To enforce the use of the new api with detailed scan results, call the constructor with an options object, see below.
      this.qrScanner = new QrScanner(
        videoElem,
        result => {
          console.log('decoded qr code:', result);
          _this.handleResult(result, _this, _store);
          // if (result) {
          //   //contains data which is the read QR code's string content and cornerPoints
          //   handleResult
          //   // this.detectedCode = JSON.stringify(result);
          // }
        },
        {
          /* your options */
          maxScansPerSecond: 10,
          highlightScanRegion: true,
          preferredCamera: 'environment',
          returnDetailedScanResult: true,
        },
      );
      this.initCompleted = true;
      // this.startScan();
    },
    async setCam(modeOrId) {
      this.qrScanner.setCamera(modeOrId)
        .then(() => {

        }); // async
    },
    async startScan() {
      try {
        console.log('startScan...');
        if (!this.initCompleted) {
          this.initScanner();
        }
        this.cams = [];
        this.started = true;
        setTimeout(() => {
          this.showHint = true;
        }, 3000);
        let _this = this;
        this.qrScanner.start()
          .then(() => {
            // List cameras after the scanner started to avoid listCamera's stream and the scanner's stream being requested
            // at the same time which can result in listCamera's unconstrained stream also being offered to the scanner.
            // Note that we can also start the scanner after listCameras, we just have it this way around in the demo to
            // start the scanner earlier.
            // QrScanner.listCameras(true)
            //   .then(cameras => cameras.forEach(camera => {
            //     // option.value = camera.id;
            //     // option.text = camera.label;
            //     _this.cams.push(camera);
            //   }));
          }).catch(err => {
          console.log('error startScan 1');
        });
      } catch (e) {
        console.log('error startScan catched ' + e.message);
      }
    },
    stopScan() {
      try {
        this.qrScanner.stop();
      } catch (e) {

      } finally {
        this.started = false;
        this.showHint = false;
      }
    },
    handleResult(raw, _this, _store) {
      if (raw && raw.data && raw.data.length > 4) {
        let q = '' + raw.data;
        // ebus.$emit('detectedQrCode', q)
        _this.detectedCode = q;
        _this.checkScannedCode();
        _this.stopScan();
        // _this.doCancle(_this, _store);
      }
    },
    checkScannedCode() {
      try {
        let code = this.detectedCode;
        console.log('checkScannedCode ' + code);

        // only comment during dev
        let splits = code.split('table=');
        if (splits[0].toLowerCase().indexOf(window.location.hostname.toLowerCase()) === -1) {
          ebus.$emit('toast', 'Der QR-Code ist fremd und kann daher nicht verwendet werden',);
          return
        }

        let query = code.substring(code.indexOf('?') + 1, code.length);
        let params = new URLSearchParams(query);
        // for (const [key, value] of params) {
        //   console.log('Qrrrr param: key ' + key + ' value ' + value);
        // }
        let _table = params.get('table');
        let table = parseTableOrNull(_table);
        // let storeFilialnummer = params.get('store'); //onlyforfranchise
        if (table) {//onlyforfranchise && storeFilialnummer) {
          console.log('parsed code table ' + table);
          //onlyforfranchise
          // let selectedStore = store.getters.stores.find(s => s.filialnummer === storeFilialnummer);
          // if (selectedStore) {
          //   store.commit('selectedStore', selectedStore);
          //   store.commit('inhouseStoreFilialnummer', storeFilialnummer);
          ebus.$emit('forceInhouseModus', {table: table});
          //   ebus.$emit('showInfo', {
          //     title: 'Du buchst jetzt auf Tisch ' + table,
          //   });
          // } else {
          //   ebus.$emit('toast', 'Die Filiale konnte nicht erkannt werden');
          // }
        } else {
          ebus.$emit('toast', 'Die Tischnummer konnte nicht erkannt werden');
        }
        this.doCancle(this, store);
      } catch (e) {
        this.doCancle(this, store);
        console.log('Qrrrr error ' + e.message);
        ebus.$emit('toast', 'Die Tischnummer konnte nicht erkannt werden');
      }
    },
  }

}
</script>

<style scoped lang="scss">
@import '../styles/base';
@import '../styles/forms';

.absCatcher {
  height: $headHeight;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  //border: 1px solid red;
}

.thePage {
  padding-top: 0;
  background-color: $bg1;
  min-height: 100vh;
}

.vVideo {
  max-width: 100vw;
  overflow-y: hidden;
}

</style>
